export default "__VITE_ASSET__CL3lq5Qi__"